import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';
import { colors } from '../../utils/colors';

const variants = {
  primary: css`
    background: ${colors.primary};
    color: ${colors.white};
    &:hover {
      background: ${colors.primaryDark};
    }
  `,
  secondary: css`
    background: transparent;
    color: ${colors.primary};
    border: 2px solid ${colors.primary};
    &:hover {
      background: ${colors.primaryLight};
    }
  `,
  ghost: css`
    background: transparent;
    color: ${colors.textDark};
    &:hover {
      background: ${colors.backgroundLight};
      color: ${colors.primary};
    }
  `
};

const sizes = {
  small: css`
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
  `,
  medium: css`
    padding: 0.75rem 1.5rem;
    font-size: 1rem;
  `,
  large: css`
    padding: 1rem 2rem;
    font-size: 1.125rem;
  `
};

const StyledButton = styled(motion.button).withConfig({
  shouldForwardProp: (prop) => !['fullWidth', 'variant', 'size'].includes(prop)
})`
  border: none;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  ${props => variants[props.variant]}
  ${props => sizes[props.size]}
  opacity: ${props => props.disabled ? 0.6 : 1};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  width: ${props => props.fullWidth ? '100%' : 'auto'};
  box-shadow: ${props => props.variant === 'primary' ? `0 4px 12px ${colors.shadow}` : 'none'};

  &:disabled {
    pointer-events: none;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px ${colors.primaryLight};
  }

  i {
    font-size: 1.1em;
  }
`;

export const Button = ({
  children,
  variant = 'primary',
  size = 'medium',
  icon,
  disabled = false,
  fullWidth = false,
  onClick,
  type = 'button',
  ...props
}) => {
  return (
    <StyledButton
      variant={variant}
      size={size}
      disabled={disabled}
      fullWidth={fullWidth}
      onClick={onClick}
      type={type}
      whileHover={!disabled && { scale: 1.02 }}
      whileTap={!disabled && { scale: 0.98 }}
      {...props}
    >
      {icon && <i className={icon}></i>}
      {children}
    </StyledButton>
  );
};